<template>
    <div class="tab-menu--main-settings" v-show="showMainSettings">
        <div class="tab-menu--main-setting" @click="openFilePlayer">
            subir imagen
            <input type="file" id="playerImageUpload" accept="image/*" @change="uploadImagePlayer" style="display: none" ref="fileInput">
        </div>
        <div v-show="playerImageLink" class="tab-menu--main-setting" @click="noBgFnFromSetting">
            quitar fondo
        </div>
        <div v-show="playerImageLink" class="tab-menu--main-setting" @click="showMainSetting('showOutlineSettings')">
            outline
        </div>
        <div v-show="playerImageLink" class="tab-menu--main-setting" @click="showMainSetting('zoomimage')">
            image sets
        </div>
    </div>

    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showOutlineSettings">
        <div @click="updateInputImageOutlineMobile" class="checkbox-mobile-setting" :class="{outlineChecked : useImageOutline}">
            <svg v-if="!useImageOutline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
            </svg>
            <svg v-else  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"/>
            </svg>
            <span>use outline</span>
        </div>
    </div>
</template>
<script>
export default {
    props: ['playerImgResizeFactor','errorMessage','useImageOutline','imgSrc','showPreviewPlayerImage','playerImageLink','cardColors','croppedImage','imageIsTooLarge','imageOutlineColor','imageOutlineWidth'],
    data() {
        return {
            showMainSettings: true,
            showOutlineSettings: false
        }
    },

    emits: ['changePlayerImage','triggerNoBg','updateInputImageOutlineMobile','updateInputImageOutlineWidth'],

    methods: {

        updateInputImageOutlineMobile() {
            console.log(this.useImageOutline)
            let data = !this.useImageOutline

            this.$emit('updateInputImageOutlineMobile', data);

        },

        showMainSetting(setting) {
            this.showMainSettings = false;
            this[setting] = true;
        },

        noBgFnFromSetting() {
            this.$emit('triggerNoBg')
        },

        openFilePlayer() {
            this.$refs.fileInput.click();
        },

        uploadImagePlayer(event) {
            this.$emit('changePlayerImage', event.target.files[0]);
        },


    }
}
</script>
<style lang="less">

.checkbox-mobile-setting {
    display: flex;
    align-items: center;

    span {
        margin-left: 0.5rem;
    }
}
</style>